import { IRadioOption } from 'components/common/FormControl/types';

export const yesNoBooleanRadioOptions: IRadioOption[] = [
  { labelKey: 'common.yes', value: true },
  { labelKey: 'common.no', value: false },
];

export const yesNoUnsureBooleanRadioOptions: IRadioOption[] = [
  ...yesNoBooleanRadioOptions,
  { labelKey: 'common.unsure', value: null },
];

/** RHF `required` treats `false` as empty for some inputs — use `validate` so Yes/No stays valid. */
export function rulesRequiredYesNo(requiredMessage: string) {
  return {
    validate: (value: unknown): true | string => {
      if (value === true || value === false) {
        return true;
      }
      return requiredMessage;
    },
  };
}

/** Yes / No / Unsure — `false` and `null` must both be valid answers. */
export function rulesRequiredYesNoUnsure(requiredMessage: string) {
  return {
    validate: (value: unknown): true | string => {
      if (value === true || value === false || value === null) {
        return true;
      }
      return requiredMessage;
    },
  };
}
